export default __webpack_public_path__ + "static/media/spotify.1936f0d2.png";